import { Link } from "react-router-dom";
import { formatViews, getHotVideos } from "@/lib/video";

export default function HotRanking() {
  const hot = getHotVideos(8);

  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-fire-line text-base" />
          </span>
          热门推荐
        </h2>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          换一批
        </Link>
      </div>
      <ul className="flex flex-col divide-y divide-background-200">
        {hot.map((video, index) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="group flex cursor-pointer items-center gap-3 py-3"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                  index < 3
                    ? "bg-accent-500 text-primary-950"
                    : "bg-background-200 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <span className="relative h-14 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={video.cover}
                  alt={video.title}
                  title={`${video.title} - 逼特逼视频`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                  {video.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-play-circle-line text-sm" />
                  {formatViews(video.views)} 次播放
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}